// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bank-picker[data-v-2587086d]{background-color:var(--bg-primary-block);border-radius:4px;border-width:1px;border-color:var(--border-primary);padding:16px 12px 16px 16px;max-height:302px;overflow-y:auto}.bank-picker__grid[data-v-2587086d]{display:grid;grid-template-columns:repeat(2,calc(50% - 7px));grid-column-gap:7px;grid-row-gap:5px}@media(min-width:1230px){.bank-picker__grid[data-v-2587086d]{grid-template-columns:repeat(4,calc(25% - 7px))}}", ""]);
// Exports
module.exports = exports;
